import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
export var AttrData = function AttrData() {
    _classCallCheck(this, AttrData);

    this.duration = 0;
    this.length = 0;
};
export var RecordPath = function RecordPath() {
    _classCallCheck(this, RecordPath);

    this.fullPath = '';
};